
import { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import axios, { AxiosResponse } from 'axios';
import t from 'react-translate';

// Schemas
import { AlertMessageType } from 'redux/schemas/app/alert-message';

// Actions
import { addAlertMessage } from 'redux/actions/alert-messages';

// Components
import NvSampleEmail from 'shared/components/nv-sample-email';
import { CommunicationType } from 'redux/schemas/models/course-communication';
import { useAppDispatch } from 'redux/store';
import { getEmailPreview } from 'redux/actions/course-communications';

type CommunicationEmailPreviewProps = {
  catalogId?: string,
  subject: string,
  body: string,
  communicationType: CommunicationType
};

const CommunicationEmailPreview = (props: CommunicationEmailPreviewProps) => {
  const dispatch = useAppDispatch();
  const catalogId = useSelector((state) => state.app.currentCatalogId);
  const catalogIdToUse = props.catalogId ?? catalogId;

  const [emailPreviewBody, setEmailPreviewBody] = useState('');
  const [emailPreviewSubject, setEmailPreviewSubject] = useState('');
  const [emailPreviewFrom, setEmailPreviewFrom] = useState('');
  const [isPreviewLoading, setIsPreviewLoading] = useState(true);

  useEffect(() => {
    if (props.subject && props.body) {
      setIsPreviewLoading(true);
      dispatch(getEmailPreview({
        catalogId: catalogIdToUse,
        subject: props.subject,
        body: props.body,
        communicationType: props.communicationType,
      }))
        .then((result) => {
          setIsPreviewLoading(false);
          setEmailPreviewBody(result.payload.body);
          setEmailPreviewSubject(result.payload.subject);
          setEmailPreviewFrom(result.payload.from);
        })
        .finally(() => {
          setIsPreviewLoading(false);
        });
    }
  }, [catalogIdToUse, props.subject, props.body]);

  return (
    <NvSampleEmail
      subject={emailPreviewSubject}
      from={emailPreviewFrom}
      content={emailPreviewBody}
      isPreviewLoading={isPreviewLoading}
    />
  );
};

export default CommunicationEmailPreview;
